<template lang="pug">
  #InvitationIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 邀請函列表
    .container-width
      b-card.m-3.mx-4.border-black.custom-shadow(
        bg-variant="light",
        v-for="(invitation,index) in invitations",
        :key="index"
        @click="$router.push({ name: 'sa-invitation-preview',params: {invitation: invitation}})"
      )
        h5 {{ invitation.invite_title }}
        img.img-fluid.w-100.h-100.rounded(:src="invitation.invite_picture_url")
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles",
        ref="infiniteLoading"
      )
        .cursor-default.mt-3(slot="no-more") 無更多邀請函
        .cursor-default.mt-3(slot="no-results") 無更多邀請函
        .cursor-default.mt-3(slot="error") 發生錯誤，請重整重試一次

</template>

<script>
  import { mapState } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import $ from 'jquery';

  export default {
  name: 'InvitationIndex',
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      id: null,
      infiniteId: +new Date(),
    };
  },
  mounted() {
    const vm = this;
    vm.initHandler();
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.commit('sa_invitation/resetInfiniteLoadingData');

      vm.$swal.close();
      vm.$store.commit('toggleLoading', false);
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;

      vm.$store.dispatch('sa_invitation/getInvitationsHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    routerBack() {
      this.$router.back();
    },
  },
  computed: {
    ...mapState({
      invitations: (state) => state.sa_invitation.invitations,
      pagination: (state) => state.sa_invitation.pagination
    })
  }
};
</script>

<style scoped>
  .border-black{
    border: 0.2rem solid #000;
    border-radius: 15px;
  }
  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
  }

  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  #header_back {
    font-size: 1.7rem;
    padding: 0.5rem;
    position: absolute;
    top: 3%;
    left: 1.6rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: #fff !important;
    z-index: 15;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-icon_arrowLeft {
    top: 0;
    left: 5px;
  }
  .icon-icon_arrowLeft:before {
    content: "\e907";
  }

  .icon-icon_location:before {
    content: "\e909";
  }
</style>
